module.exports = __webpack_public_path__ + "img/GreekTechToxotai2_ua.36aedc50.webp";